import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import UserRoleUpdateToast from '../components/UserRoleUpdateToast';
import RoleCreatedToast from '../components/RoleCreatedToast';
import actions from '../constants';

export function* newRoleToast({ result }) {
  yield call(showToast, <RoleCreatedToast code={result.code} name={result.name} />);
}

export function* editRoleToast({ result }) {
  yield call(showToast, <UpdatedToast code={result.code} name={result.name} />);
}

export function* updateUsersRoleToast({ items, role }) {
  yield call(showToast, <UserRoleUpdateToast items={items} role={role} />);
}

export function* updateUsersRoleErrorToast({ errors }) {
  yield call(showToast, <ErrorsToast operation="actions.reassign" errors={errors} name={errors[0].user.name} />);
}

export default function* rolesToasts() {
  yield takeEvery(actions.NEW_ROLE, newRoleToast);
  yield takeEvery(actions.EDIT_ROLE_SUCCESS, editRoleToast);
  yield takeEvery(actions.UPDATE_USERS_ROLE_SUCCESS, updateUsersRoleToast);
  yield takeEvery(actions.UPDATE_USERS_ROLE_ERROR, updateUsersRoleErrorToast);
}
